// AlpineJS
import Alpine from 'alpinejs'

import intersect from '@alpinejs/intersect'
 

window.Alpine = Alpine
Alpine.plugin(intersect)
Alpine.start()

// LazySizes
import 'lazysizes'

// SwiperJS
// import Swiper from 'swiper'
// import 'swiper/css'
// window.Swiper = Swiper

// AOS: https://github.com/michalsnik/aos
// import AOS from 'aos'
// import 'aos/dist/aos.css'
// AOS.init()